import { ReactElement, CSSProperties, Component, ComponentType } from 'react';

export const LAYOUT_TYPES = {
  DROPDOWN: 'Dropdown',
  DIVIDER: 'Divider',
  SPACER: 'Spacer',
  INSERT_MENU: 'InsertMenu',
} as const;

export type DropdownLayoutType = {
  key: string;
  layoutType: typeof LAYOUT_TYPES.DROPDOWN;
  buttonText: ReactElement;
  children: Array<string | SpacerLayoutType | DividerLayoutType>;
  caretRenderer?: Function;
  tooltip?: ReactElement;
};

export type InsertMenuLayoutType = {
  key: string;
  layoutType: typeof LAYOUT_TYPES.INSERT_MENU;
  children: ToolbarLayoutEntry[];
};

export type DividerLayoutType = {
  key: string;
  layoutType: typeof LAYOUT_TYPES.DIVIDER;
  style?: CSSProperties;
};

export type SpacerLayoutType = {
  key: string;
  layoutType: typeof LAYOUT_TYPES.SPACER;
};

export type ToolbarLayoutEntry =
  | string
  | typeof Component<{}>
  | { key: string; component: ComponentType<{}> }
  | SpacerLayoutType
  | DividerLayoutType
  | InsertMenuLayoutType
  | DropdownLayoutType;

/** Configuration for the Formatting Tray capability (floating toolbar on selection) */
export type FormattingTrayOptions =
  | ToolbarLayout
  | {
      /** Custom layout configuration for the formatting tray */
      layout?: ToolbarLayout;
      /** When true, keeps the formatting tray visible even when selection changes */
      shouldPersist?: boolean;
    };

export type ToolbarLayout = Array<ToolbarLayoutEntry>;
